import React, { Component } from 'react';
import { Route, Switch, NavLink, Redirect } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import get from 'lodash/get';

import Text from 'ui/Text';
import PageTitle from 'shared/PageTitle';
import QuestionnaireLayout from 'components/BaseQuestionnaire/QuestionnaireLayout';
import PageNotFound from 'shared/PageNotFound';
import twitterIcon from 'assets/twitter-logo.png';
import linkedInIcon from 'assets/linkedin-logo.png';
import { LayoutSubject } from 'shared/LayoutSubject';
import { QuestionnaireSubject } from 'shared/QuestionnaireSubject';
import Connectivity from 'shared/Connectivity';
import Auth from 'shared/Auth';
import { CDRComponentMap } from '../CDRSections/CDRComponentMap';
import { PREVIOUS_STAGE_KEY, PREVIOUS_SURVEY_API_URL } from 'utils/app-constants';
import localStorage from 'utils/localStorage';
import { PDFDownloadLink } from '@react-pdf/renderer';
import CDRDownload from 'components/CDRSections/CDRDownload';
import map from 'lodash/map';
import find from 'lodash/find';
import axios from 'utils/axios';
import ResponsesDownload from 'components/CDRSections/Responses/ResponsesDownload/index';
import DataPolicy from 'components/HomePage/DataPolicy';
import PasswordReset from 'components/HomePage/PasswordResetPage';
class ApplicationLayout extends Component {
  constructor() {
    super();

    this.state = {
      sectionQuestionnaire: localStorage.getList(get(Auth.getUser(), 'current_stage_id')),
      surveyMode: Auth.isSurveyMode(),
      loading: false,
      cdrScores: [],
      previousSurveyQuestions: [],
      previousSurveyResponses: [],
    };

    this.questionnaireListener = null;
  }

  componentDidMount() {
    if (get(Auth.getUser(), 'awards_user_id')) {
      this.retrievePreviousSurvey();
      this.fetchPreviousSurveyResponses();
    }

    this.questionnaireListener = QuestionnaireSubject.subscribe(res => {
      this.setState({ sectionQuestionnaire: [] });
    });
    this.retrieveCDR();
  }
  retrievePreviousSurvey = () => {
    this.setState({ loading: true });
    axios
      .get(`${PREVIOUS_SURVEY_API_URL}/stage/${get(Auth.getUser(), 'awards_stage_id')}`)
      .then(response => {
        const { returned_resultset } = get(response, 'data');
        console.log(get(returned_resultset, '[0]forms'));
        this.setState({
          previousSurveyQuestions: get(returned_resultset, '[0]forms'),
          loading: false,
        });
      });
  };
  fetchPreviousSurveyResponses = () => {
    this.setState({ loading: true });

    axios
      .get(`${PREVIOUS_SURVEY_API_URL}/response?user_id=${get(Auth.getUser(), 'awards_user_id')}`)
      .then(response => {
        const rawResponses = get(response.data, 'returned_resultset');

        const processedResponses = {};

        rawResponses.forEach(rawResponse => {
          let finalResponse;

          try {
            finalResponse = JSON.parse(get(rawResponse, 'response'));
          } catch (e) {
            finalResponse = get(rawResponse, 'response');
          }

          processedResponses[get(rawResponse, 'question_id')] = finalResponse;
        });

        this.setState({
          previousSurveyResponses: processedResponses,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
  retrieveCDR = () => {
    this.setState({ loading: true });

    let payload = {
      user_id: get(Auth.getUser(), 'id'),
    };

    axios
      .post(`/stage/${get(Auth.getUser(), 'current_stage_id')}/score`, payload)
      .then(response => {
        let cdrScores = map(get(response.data, `${payload.user_id}`), (score, value) => score[0]);
        this.setState({ cdrScores, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  displayScore = sectionTitle => {
    let currentScore = find(this.state.cdrScores, item => {
      let formTitle = get(item, 'form_title');

      return formTitle.match(sectionTitle);
    });

    return currentScore ? `${get(currentScore, 'score', 'N/A')}` : 'N/A';
  };

  goToAHomePage = activeRoute => {
    LayoutSubject.next({ activeRoute, showHome: true });
  };

  print = e => {
    window.print();
  };

  render() {
    if (!this.state.sectionQuestionnaire) {
      Auth.logout();
    }
    const langMap = {
      en_US: 'title',
      fr_FR: 'title_fr',
    };

    const currentLanguage = get(Auth.getLanguage(), 'lang');

    const titleKey = get(langMap, currentLanguage);

    let sections;

    sections = this.state.sectionQuestionnaire.map((section, index) => (
      <li key={index} className="navigation-item">
        <NavLink to={`/section/${get(section, 'id', '')}`} className="navigation-item__link">
          <Text type="small" modifiers="pure-white">
            {get(section, titleKey, '')}
          </Text>
        </NavLink>
      </li>
    ));

    if (!this.state.surveyMode) {
      sections = CDRComponentMap.map((cdrSection, index) => {
        if (index === 0) {
          return (
            <li key={index} className="navigation-item">
              <Text
                type="small"
                modifiers={`pure-white no-child-padding navigation-item__link ${
                  get(cdrSection, 'label') ? 'label' : ''
                }`}>
                <FormattedMessage
                  id={`Questionnaire.CDR.SubMenuItem.${get(cdrSection, 'transaltionRef')}`}
                  defaultMessage={get(cdrSection, 'name')}
                />
              </Text>
            </li>
          );
        }

        if (index === CDRComponentMap.length - 1) {
          return (
            <li key={index} className="navigation-item">
              <NavLink
                to={`/section/${get(cdrSection, 'route')}`}
                className="navigation-item__link">
                <Text type="small" modifiers="pure-white no-child-padding">
                  <FormattedMessage
                    id={`Questionnaire.CDR.SubMenuItem.${get(cdrSection, 'transaltionRef')}`}
                    defaultMessage={get(cdrSection, 'name')}
                  />
                </Text>
              </NavLink>
            </li>
          );
        }

        return (
          <li key={index} className="navigation-item">
            <NavLink to={`/section/${get(cdrSection, 'route')}`} className="navigation-item__link">
              <Text type="small" modifiers="pure-white no-child-padding">
                <FormattedMessage
                  id={`Questionnaire.CDR.SubMenuItem.${get(cdrSection, 'transaltionRef')}`}
                  defaultMessage={get(cdrSection, 'name')}
                />
              </Text>
            </NavLink>
          </li>
        );
      });
    }

    if (this.state.surveyMode) {
      let firstItem = (
        <li key="first_item" className="navigation-item">
          <NavLink to="/section/5b7a91a6ff26" className="navigation-item__link">
            <Text type="small" modifiers="pure-white no-child-padding">
              <FormattedMessage
                id="Questionnaire.BeforeYouStart"
                defaultMessage="Before You Start"
              />
            </Text>
          </NavLink>
        </li>
      );

      sections.splice(0, 0, firstItem);
    }

    sections;

    return (
      <div className="App">
        <PageTitle title="Landing Page" />
        <Connectivity />
        <section className="row no-margin dashboard-content">
          <aside id="hide-print" className="col-3 bg-primary-blue sidebar">
            <ul className="navigation-list">{sections}</ul>
          </aside>
          <div id="print" className="col-9 bg-almost-white question-content">
            <header className="top-bar justify-content-end">
              <ul className="top-bar-navigation mt-3 flex justify-content-end">
                {!this.state.surveyMode && this.state.cdrScores.length && (
                  <li className="top-bar-navigation-item__btn">
                    <a className="top-bar-navigation-item__link">
                      {!this.state.loading && (
                        <PDFDownloadLink
                          document={<CDRDownload displayScore={this.displayScore} />}
                          fileName="cdr report.pdf"
                          key={Math.random()}>
                          {({ blob, url, loading, error }) =>
                            loading ? (
                              'Loading document...'
                            ) : (
                              <Text type="small" modifiers="pure-white uppercase">
                                <FormattedMessage id="Header.Print" defaultMessage="Download CDR" />
                              </Text>
                            )
                          }
                        </PDFDownloadLink>
                      )}
                    </a>
                  </li>
                )}
                {this.state.surveyMode && get(Auth.getUser(), 'awards_user_id') ? (
                  <li className="top-bar-navigation-item__btn">
                    <a className="top-bar-navigation-item__link">
                      {this.state.previousSurveyQuestions.length && (
                        <PDFDownloadLink
                          document={
                            <ResponsesDownload
                              sections={this.state.previousSurveyQuestions}
                              responses={this.state.previousSurveyResponses}
                            />
                          }
                          fileName="cdr report.pdf">
                          {({ blob, url, loading, error }) =>
                            loading ? (
                              'Loading document...'
                            ) : (
                              <Text type="small" modifiers="pure-white uppercase">
                                <FormattedMessage
                                  id="Header.Print"
                                  defaultMessage="Download Previous Survey"
                                />
                              </Text>
                            )
                          }
                        </PDFDownloadLink>
                      )}
                    </a>
                  </li>
                ) : null}

                <li className="top-bar-navigation-item">
                  <a className="top-bar-navigation-item__link" onClick={() => Auth.logout()}>
                    <Text type="small-bold" modifiers="primary-blue uppercase">
                      <FormattedMessage id="Logout" defaultMessage="Logout" />
                    </Text>
                  </a>
                </li>
              </ul>
              <div className="icon-links"></div>
            </header>
            <div id="print-area">
              <Switch>
                <Route exact path="/section/:id" component={QuestionnaireLayout} />
                <Route exact path="/data-protection-policy" component={DataPolicy} />
                <Route exact path="/reset-password" component={PasswordReset} />
                <Redirect from="/" to="/section/5b7a91a6ff26" />
                <Route component={PageNotFound} />
              </Switch>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default ApplicationLayout;



// WEBPACK FOOTER //
// ./src/components/Layout/ApplicationLayout.js